var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00014 7.20508C6.21987 7.1988 6.42076 7.11719 6.58398 6.94141L11.3552 2.0572C11.4933 1.91908 11.5686 1.7433 11.5686 1.53613C11.5686 1.12179 11.2422 0.789062 10.8278 0.789062C10.627 0.789062 10.4323 0.870675 10.2879 1.01507L6.00642 5.41588L1.71233 1.01507C1.56794 0.876953 1.3796 0.789062 1.17243 0.789062C0.758092 0.789062 0.431641 1.12179 0.431641 1.53613C0.431641 1.7433 0.506975 1.91908 0.645089 2.0572L5.42257 6.94141C5.59208 7.11719 5.78041 7.20508 6.00014 7.20508Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.6bf00ba1ad00dbb199d7fd9054d2d920.svg";
export { ForwardRef as ReactComponent };